import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { DeclarationCustomsFlowType, DeclarationStatus } from '@e-origin/shared';

import {
  AdminBatchCounterSchema,
  AdminChangeStatusDeclarationsResponseSchema,
  AdminFixSentDeclarationsResponseSchema,
  AdminHardDeleteDeclarationsResponseSchema,
  AdminReassignDeclarationsResponseSchema,
  AdminUpdateDeclarationsResponseSchema,
} from './schemas';

const c = initContract();

export const adminDeclarationsContract = c.router({
  fixSentDeclarations: {
    method: 'POST',
    path: '/admin/fix-sent-declarations',
    body: z.object({
      lrns: z.string(),
    }),
    responses: {
      200: AdminFixSentDeclarationsResponseSchema,
    },
  },
  changeStatusDeclarations: {
    method: 'POST',
    path: '/admin/change-status-declarations',
    body: z
      .object({
        lrns: z.string(),
        status: z.nativeEnum(DeclarationStatus).optional(),
        flow: z.nativeEnum(DeclarationCustomsFlowType).optional(),
        batchCounter: AdminBatchCounterSchema,
      })
      .refine((data) => Boolean(data.status) || Boolean(data.flow), {
        message: 'At least one of status or flow must be provided',
      }),
    responses: {
      200: AdminChangeStatusDeclarationsResponseSchema,
    },
  },
  reassignDeclarations: {
    method: 'POST',
    path: '/admin/reassign-declarations',
    body: z.object({
      destinationBatchCounter: AdminBatchCounterSchema,
      lrns: z.string(),
    }),
    responses: {
      200: AdminReassignDeclarationsResponseSchema,
    },
  },
  hardDeleteDeclarations: {
    method: 'POST',
    path: '/admin/hard-delete-declarations',
    body: z.object({
      lrns: z.string(),
    }),
    responses: {
      200: AdminHardDeleteDeclarationsResponseSchema,
    },
  },
  fixReleaseDeclarations: {
    method: 'POST',
    path: '/admin/fix-release-declarations',
    body: z.object({
      batchCounter: AdminBatchCounterSchema,
    }),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  updateDeclarations: {
    method: 'GET',
    path: '/admin/update-declarations',
    responses: {
      200: AdminUpdateDeclarationsResponseSchema,
    },
  },
  decryptFromImporter: {
    method: 'POST',
    path: '/declarations/decrypt-from-importer',
    body: c.noBody(),
    responses: {
      200: z.object({ successRate: z.number().nullable() }),
    },
  },
});
